import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import { statusInfo } from "./statusDespesaRecorrente";

dayjs.locale("pt-br");

const DIAS_SEMANA = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"];

export default function CalendarioDespesasRecorrentes({ mes, ocorrencias, onMesChange, onSelecionar }) {
    const inicioMes = dayjs(`${mes}-01`);
    const diasNoMes = inicioMes.daysInMonth();
    // dayjs.day(): 0=Domingo..6=Sábado — convertido para índice com Segunda-feira primeiro.
    const primeiroDiaSemana = (inicioMes.day() + 6) % 7;

    const porDia = {};
    (ocorrencias || []).forEach(o => {
        if (!o.dataLancamentoProgramada) return;
        (porDia[o.dataLancamentoProgramada] ||= []).push(o);
    });

    const celulas = [
        ...Array(primeiroDiaSemana).fill(null),
        ...Array.from({ length: diasNoMes }, (_, i) => i + 1),
    ];

    const hojeStr = dayjs().format("YYYY-MM-DD");

    return (
        <div className="bg-card border border-border rounded-lg shadow-card p-4">
            <div className="flex items-center justify-between mb-4">
                <button
                    type="button"
                    onClick={() => onMesChange(inicioMes.subtract(1, "month").format("YYYY-MM"))}
                    className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-muted text-muted-foreground transition-colors"
                    aria-label="Mês anterior"
                >
                    ‹
                </button>
                <span className="font-display font-semibold text-base capitalize text-foreground select-none">
                    {inicioMes.format("MMMM [de] YYYY")}
                </span>
                <button
                    type="button"
                    onClick={() => onMesChange(inicioMes.add(1, "month").format("YYYY-MM"))}
                    className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-muted text-muted-foreground transition-colors"
                    aria-label="Próximo mês"
                >
                    ›
                </button>
            </div>

            <div className="grid grid-cols-7 text-center text-xs font-medium text-muted-foreground mb-1 select-none">
                {DIAS_SEMANA.map(d => <div key={d} className="py-1">{d}</div>)}
            </div>

            <div className="grid grid-cols-7 gap-1">
                {celulas.map((dia, idx) => {
                    if (!dia) return <div key={idx} className="min-h-[92px] rounded-md bg-muted/20" />;
                    const dataStr = inicioMes.date(dia).format("YYYY-MM-DD");
                    const eventos = porDia[dataStr] || [];
                    const isHoje = dataStr === hojeStr;
                    return (
                        <div
                            key={idx}
                            className={`min-h-[92px] rounded-md border p-1.5 flex flex-col gap-1 ${isHoje ? "border-primary bg-primary/5" : "border-border"}`}
                        >
                            <span className={`text-xs font-medium ${isHoje ? "text-primary" : "text-muted-foreground"}`}>{dia}</span>
                            <div className="flex flex-col gap-1 overflow-y-auto">
                                {eventos.map(ev => {
                                    const cfg = statusInfo(ev.status);
                                    return (
                                        <button
                                            key={ev.id}
                                            type="button"
                                            onClick={() => onSelecionar(ev)}
                                            title={`${ev.descricao} — ${cfg.label}`}
                                            className={`w-full text-left text-[11px] leading-tight px-1.5 py-0.5 rounded truncate hover:brightness-95 transition-all ${cfg.badge}`}
                                        >
                                            {cfg.emoji} {ev.descricao}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
